import { render, staticRenderFns } from "./InvoiceDialog_Stocks.vue?vue&type=template&id=56649b98&scoped=true"
import script from "./InvoiceDialog_Stocks.vue?vue&type=script&lang=js"
export * from "./InvoiceDialog_Stocks.vue?vue&type=script&lang=js"
import style0 from "./InvoiceDialog_Stocks.vue?vue&type=style&index=0&id=56649b98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56649b98",
  null
  
)

export default component.exports